// Loyola University Chicago's undergraduate majors (#2743). Read on
// 2026-10-01 from the official 2026-2027 Academic Catalog's Programs A-Z
// (catalog.luc.edu/programs), keeping every undergraduate program whose
// degree is a bachelor's (BA, BS, BBA, BSEd, BSN, BSW), under the school its
// catalog path names. Folded into their major: tracks, concentrations,
// emphases and specializations ("Biology with Ecology Emphasis (BS)" is
// Biology, "Engineering with a Computer Engineering Specialization (BS)" is
// Engineering). Left out: minors, certificates, Arrupe College's associate
// degrees and its AA + Nursing pathway, the Accelerated BSN (for students
// who already hold a degree), the U.S./Europe Double Degree, the Physics
// (BS) + Engineering (BS) dual degree, the English (BA/BSED) combination,
// honors programs and graduate programs. The School of Continuing and
// Professional Studies' majors are kept as the catalog lists them. The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "loyola-university-chicago",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Loyola's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Concentrations and tracks are folded into their major; minors, certificates, associate degrees, dual-degree combinations and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, College of Arts and Sciences",
                "url": "https://catalog.luc.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "African Studies and the African Diaspora",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Greek",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive and Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Molecular and Cellular Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Photography and Video Art",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics with Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sculpture and Ceramics",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology-Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theology",
                    "degree": "BA"
                },
                {
                    "name": "Theoretical Physics and Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Visual Communication",
                    "degree": "BA"
                },
                {
                    "name": "Women's Studies and Gender Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Marcella Niehoff School of Nursing",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, Marcella Niehoff School of Nursing",
                "url": "https://catalog.luc.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Parkinson School of Health Sciences and Public Health",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, Parkinson School of Health Sciences and Public Health",
                "url": "https://catalog.luc.edu/undergraduate/health-sciences-public-health/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Quinlan School of Business",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, Quinlan School of Business",
                "url": "https://catalog.luc.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Accounting and Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Information Systems and Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Sport Management",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Communication",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, School of Communication",
                "url": "https://catalog.luc.edu/undergraduate/communication/"
            },
            "majors": [
                {
                    "name": "Advertising & Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Advertising Creative",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Public Communication and Advocacy",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Continuing and Professional Studies",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, School of Continuing and Professional Studies",
                "url": "https://catalog.luc.edu/undergraduate/continuing-professional-studies/"
            },
            "majors": [
                {
                    "name": "Applied Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Studies",
                    "degree": "BA"
                },
                {
                    "name": "Information Technology",
                    "degree": "BA"
                },
                {
                    "name": "Management",
                    "degree": "BA"
                },
                {
                    "name": "Paralegal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Strategic Digital Communication",
                    "degree": "BA"
                },
                {
                    "name": "Web Technologies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, School of Education",
                "url": "https://catalog.luc.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Bilingual/Bicultural Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Grades",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Special Education",
                    "degree": "BSEd"
                }
            ]
        },
        {
            "name": "School of Environmental Sustainability",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, School of Environmental Sustainability",
                "url": "https://catalog.luc.edu/undergraduate/environmental-sustainability/"
            },
            "majors": [
                {
                    "name": "Environmental Economics & Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Policy",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Loyola 2026-2027 Academic Catalog, School of Social Work",
                "url": "https://catalog.luc.edu/undergraduate/social-work/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
